import {
    FETCH_EXCEPTION_NOTONERA_INVOICELIST_FAILURE,
    FETCH_EXCEPTION_NOTONERA_INVOICELIST_SUCCESS,
    FETCH_EXCEPTION_NOTONERA_INVOICELIST_REQUEST,
  } from "./FetchPaymentExceptionEraTypes";
  import api from "../../utils/Api";
  import axios from 'axios';
  
  export const fetchNotOnEraInvoiceListRequest = () => {
    return {
      type: FETCH_EXCEPTION_NOTONERA_INVOICELIST_REQUEST,
    };
  };
  
  export const fetchNotOnEraInvoiceListSuccess = (notOnEraInvoiceList) => {
    return {
      type: FETCH_EXCEPTION_NOTONERA_INVOICELIST_SUCCESS,
      payload: notOnEraInvoiceList,
    };
  };
  
  export const fetchNotOnEraInvoiceListFailure = (error) => {
    return {
      type: FETCH_EXCEPTION_NOTONERA_INVOICELIST_FAILURE,
      payload: error,
    };
  };
  
  const CancelToken = axios.CancelToken;
  let cancelRequest;
  export const fetchNotOnEraInvoiceList = (searchKey, sortBy, page, payload) => {
    //cancel previous request if multiple hits done.
    cancelRequest && cancelRequest();
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "payment/paymentException/fetch?search_key=" +
    searchKey +
    "&sort_by=" +
    sortBy +
    "&page=" +
    page;
  
    if(payload && payload.dateFrom && payload.dateFrom !== "Not Available"){
      url += "&service_start_date=gte:"+ payload.dateFrom;
    }
    if(payload && payload.dateTo && payload.dateTo !== "Not Available"){
        url += "&service_start_date=lte:"+ payload.dateTo;
    }
    if(payload && payload.status){
        url += "&status="+ payload.status;
    }
  
    return async (dispatch) => {
      dispatch(fetchNotOnEraInvoiceListRequest());
      try {
        const response = await api.get(
         url,
          {
            headers: headers,
            cancelToken: new CancelToken(function executor(c) {
              cancelRequest = c;
          })
          }
        );
        const notOnEraInvoiceList = response.data.data;
        //console.log("*************** invoiceList", invoiceList);
        dispatch(fetchNotOnEraInvoiceListSuccess(notOnEraInvoiceList));
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Error: ', error.message); // => prints: Api is being canceled
        } 
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchNotOnEraInvoiceListFailure(errorMsg));
      }
    };
  };
  